import React, { useEffect } from 'react';

import WithLoading from '../../../Hoc/WithLoading';
import OrderListView from './OrderListView';

const OrderList = () => {
  const getOrderList = `/order/current-user`;
  useEffect(() => {}, []);
  return <WithLoading component={OrderListView} url={getOrderList} />;
};

export default OrderList;
